import { useEffect, useRef } from 'react';

/**
 * @param {()=> void} cb
 * @param {IntersectionObserverInit} options
 * @returns {import('react').MutableRefObject} A ref to be added to the element who's visibility will trigger the callback
 */
const useElementOnScreenCallback = (cb, options) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref?.current || typeof cb !== 'function') return;

    const currentRef = ref.current;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        cb();
        observer.unobserve(entry.target);
      }
    }, options);

    observer.observe(currentRef);
    return () => observer.unobserve(currentRef);
  }, [cb, options]);
  return ref;
};

export default useElementOnScreenCallback;
